import { z } from 'zod';
export const AdminLoginRequestSchema = z.object({
    email: z.string().email(),
    password: z.string().min(1),
});
export const CustomerSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    contactEmail: z.string().email().nullable(),
    domain: z.string().nullable(),
    notes: z.string().nullable(),
    createdAt: z.string().datetime(),
});
export const CreateCustomerRequestSchema = z.object({
    name: z.string().min(1).max(200),
    contactEmail: z.string().email().optional(),
    domain: z.string().max(200).optional(),
    notes: z.string().max(2000).optional(),
});
//# sourceMappingURL=admin.js.map